<h3>Add User</h3>
<user-edit-form [model]="model | async" [locationId]="_locationId" (onSave)="saveUser($event)" (onCancel)="cancel()"></user-edit-form>
